import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import './index.scss';
import Truncate from 'react-truncate';

const AuthorProfile = ({
  authorName = '',
  authorQualifications,
  authorTitle = '',
  authorProfileLink = '',
  authorImg,
  authorDes = '',
  description = '',
  className
}) => {
  const DISPLAY_LINES = 3;
  const [showMore, setShowMore] = useState(true);
  const [isTruncate, setIsTruncated] = useState(null);
  return (
    <div className={className}>
      <div className="userActions">
        <div className="userImg">
          <LazyLoadImage
            src={authorImg ? authorImg : '/content/images/icons/logo-icon.png'}
            height="44px"
            width="44px"
            alt=""
          />
        </div>
        <div className="userDataDes">
          <span>{authorTitle}</span>&nbsp;
          <a href={authorProfileLink}>
            {authorName}
            {authorQualifications && <>,&nbsp;{authorQualifications}</>}
          </a>
          <div>{authorDes}</div>
        </div>
      </div>
      {description && (
        <div className="descriptionPara">
          <Truncate
            lines={showMore ? DISPLAY_LINES : 0}
            onTruncate={bool => {
              isTruncate == null && setIsTruncated(bool);
              setShowMore(bool);
            }}
            trimWhitespace={true}
            ellipsis={
              <span
                onClick={() => {
                  setShowMore(!showMore);
                }}
              >
                ...&nbsp;<label>Read more</label>
              </span>
            }
          >
            {description}
          </Truncate>
        </div>
      )}
    </div>
  );
};

export default AuthorProfile;
